/**
 * @deprecated Use getTagDisplayName in src/app/modules/tags/utils.ts instead
 */
export default function getFullTagName(
  tagType: string,
  tagName: string,
): string {
  return `${tagType}:${tagName}`;
}
